'use strict';

// eslint-disable-next-line max-lines-per-function
angular.module('webAgro1App').service('OperacoesService', function($http, $q, RestService) {
  const OPERACAO_VS_URL = {
    stand: 'contagens/resumo',
    produtividade: 'produtividade_contagens/resumo'
  };
  const TIPO_INSUMO = 1;

  // eslint-disable-next-line complexity
  const getParamsFilters = function(filters) {
    return {
      atividade: filters.atividades || (filters.cultura ? filters.cultura.id : null) || null,
      gleba: filters.gleba ? filters.gleba.id : null,
      dia: filters.dia || null,
      propriedade: filters.propriedade || null,
      safra: filters.safra ? filters.safra.id : null,
      usuario: filters.usuario || null,
      tipo: filters.tipo || null,
      ocorrencia: filters.ocorrencia || null,
      operacao: typeof filters.operacao === 'number' ? filters.operacao : null,
      start_date: filters.startDate,
      end_date: filters.endDate,
      cultivar: filters.cultivar && filters.cultivar.item_id !== 'todas' ? filters.cultivar.item_id : null
    };
  };

  const getHttpUrlData = function(caminho, filters, version) {
    filters = filters ? getParamsFilters(filters) : null;
    const url = SERVER + (version || API_VERSION) + caminho;
    return $http.get(url, { params: filters });
  };

  return {
    atividades: function() {
      return getHttpUrlData('operacoes_campo/atividades');
    },

    datas: function(filters) {
      const deferred = $q.defer();

      const url = `${SERVER + API_VERSION }operacoes_campo/datas`;
      $http.get(url, { params: filters }).then(function(result) {
        const transformedDatas = result.data.map(function(data) {
          return new Date(`${data } 0:00:00`);
        });
        deferred.resolve(transformedDatas);
      })
        .catch(deferred.reject);

      return deferred.promise;
    },

    usuarios: function(filters) {
      const deferred = $q.defer();

      const url = `${SERVER + API_VERSION }operacoes_campo/usuarios`;
      $http.get(url, { params: filters }).then(function(result) {
        const usuarios = result.data.map(function(usuario) {
          return {
            id: usuario.id,
            nome: usuario.nome,
            nomeCompleto: usuario.nome_completo
          };
        });
        deferred.resolve(usuarios);
      })
        .catch(deferred.reject);

      return deferred.promise;
    },

    alertas: function(filters) {
      return getHttpUrlData('operacoes_campo/alertas', filters);
    },

    resumoGlebas: function(filters) {
      return getHttpUrlData('operacoes_campo/alertas', filters, 'v2/');
    },

    getHistoryGleba: function(filters) {
      return getHttpUrlData('operacoes_campo/history_gleba', filters);
    },

    getHistoryGlebaV2: function(filters) {
      return $http.post(`${SERVER }v2/operacoes_campo/history_gleba`, filters);
    },

    getHistoryGlebaV2Paginated: function(config) {
      return RestService.postToUrl(`${SERVER }v2/operacoes_campo/history_gleba`, config);
    },

    getOperationsDayGleba: function(filters) {
      return getHttpUrlData('operacoes_campo/visitas', filters);
    },

    getSpraysHistory: function(filters) {
      return getHttpUrlData('operacoes_campo/pulverizacoes', filters);
    },

    // eslint-disable-next-line complexity
    getOperationSummary: function(filters) {
      const deferred = $q.defer();
      const isValidFilters = (filters && filters.gleba && filters.operacao && filters.cultivar);

      if (!isValidFilters) {
        deferred.resolve({});
      } else {
        const url = SERVER + API_VERSION + OPERACAO_VS_URL[filters.operacao.tipo];
        const params = {
          gleba: filters.gleba.id,
          tp_insumo: TIPO_INSUMO,
          cd_insumo: filters.cultivar.id,
          data_inicial: filters.dia || filters.dataInicial,
          data_final: filters.dia || filters.dataFinal,
          safra: filters.safra || null
        };

        $http.get(url, { params: params }).then(function(result) {
          deferred.resolve(result.data);
        }, deferred.reject);
      }

      return deferred.promise;
    },

    getTipoOperacoesCampo: function() {
      return $http.get(`${SERVER + API_VERSION }operacoes`);
    },

    getTipoOperacoesCampoParaSemeadura: function() {
      return $http.get(`${SERVER + API_VERSION }operacoes`, { params:
        { operacao: 'semeadura' } });
    },

    getTipoOperacoesCampoParaAdubacao: function() {
      return $http.get(`${SERVER + API_VERSION }operacoes`, { params:
        { operacao: 'adubacao' } });
    },

    getTipoOperacoesCorrecaoDeSolo: function() {
      return $http.get(`${SERVER + API_VERSION }operacoes`, { params:
        { operacao: 'correcao_solo' } });
    },

    getTipoOperacoesCampoParaColheita: function() {
      return $http.get(`${SERVER + API_VERSION }operacoes`, { params:
        { operacao: 'colheita' } });
    },

    getTipoOperacoesCampoParaTratamentoSemente: function() {
      return $http.get(`${SERVER + API_VERSION }operacoes`, { params:
        { operacao: 'tratamento_semente' } });
    },

    getTipoOperacoesTodas: function() {
      return $http.get(`${SERVER + API_VERSION }operacoes`, { params:
        { operacao: 'all' } });
    }
  };
});
